import React from 'react';
import { useTranslation } from 'react-i18next';

const EmptyGrid = (props: any) => {
  const { t } = useTranslation();

  return (
    <div className="event-grid-container">
      <div
        className="empty-grid"
        style={{
          height: props.height ? props.height : '675px',
          width: '100%',
        }}
      >
        <span>{t('common.grid.noResults')}</span>
      </div>
    </div>
  );
};

export { EmptyGrid }; // eslint-disable-line
